// components/CustomDialog.tsx
import { ReactNode } from "react";
import {
  Dialog,
  Portal,
  CloseButton,
  Button,
  Text,
  Flex
} from "@chakra-ui/react";
//icons
// import { IoAlertCircleOutline } from "react-icons/io5";
import { AlertCircle } from 'lucide-react';

type CustomDialogProps = {
  open: boolean;
  onClose: (details: { open: boolean }) => void;
  title: string;
  body: string | ReactNode;
  body2?: string | ReactNode;
  onConfirm?: () => void;
  onCancel?: () => void;
  confirmText?: string;
  cancelText?: string;
  showConfirmButton?: boolean;
  icon?: ReactNode;
  titleBg?:string;
};

export function CustomDialog({
  open,
  onClose,
  title,
  body,
  body2,
  onConfirm,
  onCancel,
  confirmText = "Confirmar",
  cancelText = "Cancelar",
  showConfirmButton = true,
  icon,
  titleBg = "red-wine",
}: CustomDialogProps) {
  return (
    <Dialog.Root open={open} onOpenChange={(details) => onClose(details)}>
      <Portal>
        <Dialog.Backdrop bg="blackAlpha.300" />
        <Dialog.Positioner  px={["4","0"]}>
          <Dialog.Content bg="gray.50" color="black" boxShadow="lg" borderRadius="xl">
            <Dialog.Header bg={titleBg} color="white" borderTopRadius="lg" boxShadow="0px 2px 4px color-mix(in srgb, black 64%, transparent),0px 0px 1px inset color-mix(in srgb, var(--chakra-colors-gray-300) 30%, transparent)">
              <Dialog.Title as={Flex} alignItems="center" gap={2}>
                {icon ? icon : <AlertCircle size={24} />}
                <Text as="span">{title}</Text>
              </Dialog.Title>
            </Dialog.Header>
            <Dialog.Body mt="2">
              {typeof body === "string" ? <Text>{body}</Text> : body}
            </Dialog.Body>
            {body2 && (
              <Dialog.Body>
                {typeof body2 === "string" ? <Text>{body2}</Text> : body2}
              </Dialog.Body>
            )}
            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button
                  variant="solid"
                  bg="white"
                  boxShadow="0px 2px 4px color-mix(in srgb, black 64%, transparent),0px 0px 1px inset color-mix(in srgb, var(--chakra-colors-gray-300) 30%, transparent)"
                  transition="all 0.2s ease-in-out"
                  fontWeight="bold"
                  color="black"
                  _focusVisible={{ boxShadow: "none" }}
                  _hover={{ transform: "scale(1.05)" }}
                  onClick={() => onCancel?.()}
                >
                  {cancelText}
                </Button>
              </Dialog.ActionTrigger>
              {showConfirmButton && (
                <Button
                  variant="solid"
                  bg="red-wine"
                  boxShadow="0px 2px 4px color-mix(in srgb, black 64%, transparent),0px 0px 1px inset color-mix(in srgb, var(--chakra-colors-gray-300) 30%, transparent)"
                  transition="all 0.2s ease-in-out"
                  fontWeight="bold"
                  color="white"
                  _hover={{ transform: "scale(1.05)" }}
                  onClick={onConfirm}
                >
                  {confirmText}
                </Button>
              )}
            </Dialog.Footer>
            <Dialog.CloseTrigger asChild>
              <CloseButton position="absolute" right={3} top={3} size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
}
